export default "__VITE_ASSET__DlVEyREM__"